import ApiResponse from "sr/models/ApiResponse";
import { remove } from "sr/utils/axios";

export const deleteMedical = async (queryParams) => {
    try {
  return await remove<ApiResponse<[]>>(`/cleaner/medical?${queryParams}`).then((res)=>{
        if(res?.success===true){
            return res
        }
        else {
            return null
        }
  }
)
    }
    catch(e){

    }
};
